module.exports = __webpack_public_path__ + "img/feature-11-1.75329a79.png";